export default __webpack_public_path__ + "static/media/compass.c8467998.svg";